import { style } from "@vanilla-extract/css";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "@huub-web/ui/theme/css/theme.css";

export const gridStyle = style({
  gridTemplateColumns: "repeat(1, 1fr) !important",
  ...responsiveContainer({
    600: {
      gridTemplateColumns: "repeat(5, 1fr) !important",
    },
  }),
});

export const titleContainerStyle = style({
  position: "relative",
  height: "100%",
  width: "100%",
  paddingBottom: theme.spacings.m,
  ...responsiveContainer({
    600: {
      textAlign: "left",
      gridColumn: "span 2",
      maxWidth: rem(300),
      paddingBottom: 0,
    },
  }),
});

export const titleStyle = style({
  textAlign: "center",
  ...responsiveContainer({
    600: {
      textAlign: "left",
      position: "sticky",
      top: theme.spacings.xxl2,
      zIndex: 1,
    },
  }),
});

export const listStyle = style({
  gridColumn: "span 2",
  gap: theme.spacings.s,
  ...responsiveContainer({
    600: {
      gap: theme.spacings.m,
      gridColumn: "span 3",
      paddingTop: theme.spacings.m,
    },
  }),
});
